export default function(message) {
    console.warn(`[Bootstrap-Vue warn]: ${message}`);
}
